export const getPrimaryColor = (survey) => {
  return survey?.primary_color || 'rgb(50, 142, 205)';
};

export const getSecondaryColor = (survey) => {
  return survey?.secondary_color || 'rgb(148, 235, 255)';
};

export const getCompanyLogo = (survey) => {
  return (
    survey?.company_logo ||
    'https://cinchio-logos.s3.amazonaws.com/6/Artboard_2_copy.png?1512149267'
  );
};
